import { createContext } from "../../utils/createContext";

import type { RadioClassNames, RadioSlots } from "./radioVariants";

export interface RadioContext {
  slots: RadioSlots;
  classNames?: RadioClassNames;
}

// Use strict: false so Radio can work standalone without RadioGroup
export const [RadioProvider, useRadioContext] = createContext<RadioContext>({
  name: "RadioContext",
  strict: false,
});
